import palette from '../palette';
import { fade } from '@material-ui/core/styles';

export default {
  root: {
    boxShadow: `0 20px 20px -10px ${fade(palette.primary[100], 0.7)}`,
  },
};
